import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import auth from "./auth.js";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export default new Vuex.Store({
  state: {
    site: [],
    projects: [],
    editions: [],
    about: [],
    terms: [],
    custom: [],
    shop: [],
    cart: [],
  },
  actions: {
    async loadContent({ commit }) {
      await axios
        .get("/api/data", {
          withCredentials: true,
          auth: {
            username: auth.u,
            password: auth.p
          }
        })
        .then(function(response) {
          commit("SET_SITE", response.data.site);
          commit("SET_PROJECTS", response.data.projects);
          commit("SET_SHOP", response.data.shop);
          commit("SET_EDITIONS", response.data.editions);
          commit("SET_ABOUT", response.data.about);
          commit("SET_TERMS", response.data.terms);
          commit("SET_CUSTOM", response.data.custom);
        });
    }
  },
  getters: {
      totalAmount: (state) => {
        let amount = 0;
        state.cart.forEach((item) => (amount += item.content.price * item.quantity));
        console.log(amount);
        return amount;
      },
  },
  mutations: {
      addToCart({ cart }, product) {
            const itemIndex = cart.findIndex((item) => item.id === product.id);
            if (itemIndex < 0) {
                  cart.push(product);
            } else {
                  cart[itemIndex].quantity++;
            }
      },
      removeFromCart({ cart }, productid) {
            const itemIndex = cart.findIndex((item) => item.id === productid);
            cart.splice(itemIndex, 1);
      },
      SET_SITE(state, site) {
            state.site = site;
      },
      SET_PROJECTS(state, projects) {
            state.projects = projects;
      },
      SET_SHOP(state, data) {
            state.shop = data;
      },
      SET_EDITIONS(state, editions) {
            state.editions = editions;
      },
      SET_ABOUT(state, about) {
            state.about = about;
      },
      SET_TERMS(state, data) {
            state.terms = data;
      },
      SET_CUSTOM(state, about) {
            state.custom = about;
      }
  }
});
